<template>
  <div id="app" class="app">
    <HeaderVue></HeaderVue>
    <router-view></router-view>
    <notifications position="top center" group="foo" />
  </div>
</template>

<script>
import HeaderVue from '@/components/HeaderVue.vue'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    HeaderVue
  },
  computed: {
    isAuthorized () {
      return this.$store.getters.value('isAuthorized')
    }
  },
  data () {
    return {
      interval: null,
      initApp: true
    }
  },
  mounted () {
    if (this.isAuthorized && this.initApp) {
      this.initApp = false
      this.intervalAccessToken()
    }
  },
  methods: {
    intervalAccessToken () {
      this.interval = setInterval(() => {
        this.getAccessToken().then(response => {
          this.$cookies.set('access', response.data.token)
          axios.defaults.headers.common['Authorization'] = 'JWT ' + this.$cookies.get('access')
          this.setUserInfoMix(response.data.token)
        }).catch(error => {
          this.clearCookies()
          this.$router.push('/login')
          console.warn('Failed to update token')
          console.log(error)
        })
        // console.log('update access')
      }, 1000 * 60 * 4)
    }
  },
  watch: {
    isAuthorized (newV) {
      if (newV) {
        this.intervalAccessToken()
      } else {
        clearInterval(this.interval)
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/main.scss';
@import 'node_modules/vue-select/src/scss/vue-select.scss';

.popup-opacity-enter-active,
.popup-opacity-leave-active {
  transition: all .2s;
}
.popup-opacity-enter,
.popup-opacity-leave-to {
  opacity: 0;
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: rgba(0, 0, 0, 0.85);
    color: white;
    border-radius: 10px;
    padding:10px;
    font-size: 12px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: rgba(0, 0, 0, 0.85);
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 20px;

    .tooltip-arrow {
      border-width: 15px 15px 15px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -15px;
      top: calc(50% - 15px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

html,
body {
  height: 100%;
  min-height: 100%;
  overflow: hidden;
}

.land-tlu {
  .jstree-themeicon {
    display: none;
  }
}

.mapboxgl-canvas {
  &:focus {
    outline: none;
  }
}
// поправить контрол
.mapboxgl-ctrl-top-right {
  top: 50%!important;
  transform: translateY(-50%)!important;
}

.app {
  min-height: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.btn {
  border-radius: 8px;
  padding: 12px 20px;
}

.accent-btn {
  color: #fff;
  background-color: #4E53E7;
  transition: .3s;
  &:hover {
    background-color: #373cc2;
  }
}

.disabled-btn {
  background-color: #eeeefd;
}

.btn-add {
  margin-top: 20px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  border: 1px dashed #e6e6e6;
  color: #4E53E7;
  transition: .3s;
  &:hover {
    border-color: #4E53E7;
  }
  span {
    display: inline-block;
    vertical-align: bottom;
    margin-right: 5px;
    font-size: 24px;
  }
}

.content {
  position: relative;
  display: flex;
  height: 100%;
  flex: 1 1 auto;
}

.v-select {
  font-size: 13px;
}

.vs__actions {
  margin-top: 3px;
  margin-right: 15px;
  background-image: url(~@img/down.svg);
  background-position: 50% 50%;
  background-repeat: no-repeat;
  transition: .3s;
  svg {
    display: none;
  }
}

.vs--open {
  .vs__actions {
    transform: rotate(180deg);
  }
}

.vs__clear {
  display: none;
}
.vs__dropdown-toggle {
  font-size: 14px;
  border-radius: 8px;
  min-height: 40px;
  border-color: #e6e6e6;
}
.vs__search, .vs__search:focus {
  color: #d2d2d2;
}
.vs__dropdown-option {
  font-size: 14px;
  white-space: normal;
  width: 100%;
  transition: .3s;
  &:hover {
    width: 100%;
    background-color: #4E53E7;
  }
}

.vs__selected {
  align-items: flex-start;
  margin-top: 9px;
}

.vs__selected-options {
  width: 100%;
  padding: 0;
}

.vs__dropdown-option--highlight {
  width: 100%;
  background-color: #4E53E7;
}

.vdp-datepicker {
  background-image: url(~@img/calendar.svg);
  background-position: 97% 50%;
  background-repeat: no-repeat;
  input {
    background-color: transparent;
  }
}
.vue-dadata__input {
  height: 42px!important;
  border-color: #4e53e7!important;
  &:focus {
    border-color: #4e53e7!important;
  }
}

.calculated-area {
  position: absolute;
  padding: 5px;
  font-size: 12px;
  background-color: #fff;
  bottom: 5px;
  left: 5px;
  p {
    margin-bottom: 0;
  }
}
</style>

<style lang="scss">
.mapboxgl-popup-content {
  border-radius: 10px;
  padding-right: 0;
}
.mapboxgl-popup-close-button {
  position: absolute;
  font-size: 26px;
  top: 10px;
  right: 10px;
  z-index: 3;
  &:hover {
    background: transparent;
  }
}
.popup {
  &-wrapper {
    position: relative;
    max-height: 250px;
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 5px;
    &-tooltip {
      .popup-name {
        padding-right: 10px;
      }
    }
    .rent-img {
      position: absolute;
      top: 0;
      right: 55px;
    }
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #cccccc;
      border-radius: 3px;
    }
  }
  &-name {
    font-weight: bold;
    padding-right: 80px;
    margin-right: 0px;
    p {
      margin-bottom: 0;
      padding-right: 0px;
    }
  }

  &-location {
    margin-top: 10px;
    line-height: 16px;
  }

  &-detail {
    position: absolute;
    width: 14px;
    height: 14px;
    top: 3px;
    right: 30px;
    cursor: pointer;
    @media screen and (max-width: 768px){
      display: none;
    }
  }
}
.popup_ngw_layer-properteis_item {
  display: flex;
  // width: 270px;
  justify-content: space-between;
  p {
    margin: 0;
    font-size: 13px;
    max-width: 49%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Montserrat_R';
  }
}
.popup_ngw_layer-properteis_feature {
  padding: 0 5px;
}
.popup_ngw_layer-properteis_feature:not(:last-child) {
  border-bottom: 1px solid black;
  padding-bottom: 5px;
  margin-bottom: 5px;
}
.popup_ngw_layer-name {
  font-weight: bold;
  margin-bottom: 5px;
  margin-top: 5px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue